var _script, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 489.25 168.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    type: "text/javascript"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_9);}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_9-2);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_9-3);}.cls-4{fill:#ffffff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9",
    x1: 12.54,
    y1: 176.16,
    x2: 81.71,
    y2: 106.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4c503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9-2",
    x1: -22.66,
    y1: 140.97,
    x2: 46.52,
    y2: 71.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9-3",
    x1: -57.94,
    y1: 105.68,
    x2: 11.23,
    y2: 36.51,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_9"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-iExec") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.84,168.59A23.88,23.88,0,0,1,21.07,121a23.27,23.27,0,0,1,2.77-.16,23.72,23.72,0,0,1,12.71,3.67,8.58,8.58,0,0,0,4.59,1.31,9.34,9.34,0,0,0,4.8-1.34,9.08,9.08,0,0,0,4.44-8.3A23.89,23.89,0,0,1,71.56,90.77a25.74,25.74,0,0,1,2.63-.14,23.77,23.77,0,0,1,12.7,3.67,8.55,8.55,0,0,0,4.61,1.32,9.24,9.24,0,0,0,4.78-1.33l.11-.07A9,9,0,0,0,100.72,86a23.89,23.89,0,0,1,21.5-25.45c.77-.07,1.55-.11,2.32-.11A23.88,23.88,0,0,1,127.31,108a23.39,23.39,0,0,1-2.77.16h0a23.78,23.78,0,0,1-12.72-3.67,8.54,8.54,0,0,0-4.58-1.32,9.33,9.33,0,0,0-4.8,1.35,9.08,9.08,0,0,0-4.44,8.3,23.87,23.87,0,0,1-36.53,21.88,8.54,8.54,0,0,0-4.61-1.31,9.3,9.3,0,0,0-4.79,1.33l-.1.06A9.08,9.08,0,0,0,47.63,143a24.36,24.36,0,0,1,0,3.82,23.82,23.82,0,0,1-21.43,21.63C25.38,168.55,24.62,168.59,23.84,168.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.84,108.17A23.88,23.88,0,0,1,21.1,60.61a23.27,23.27,0,0,1,2.77-.16,23.72,23.72,0,0,1,12.71,3.67,8.5,8.5,0,0,0,4.59,1.31A9.25,9.25,0,0,0,46,64.09a9.06,9.06,0,0,0,4.44-8.3,23.89,23.89,0,0,1,21.5-25.45c.77-.07,1.55-.11,2.31-.11A23.88,23.88,0,0,1,77,77.81a23.43,23.43,0,0,1-2.78.16A23.72,23.72,0,0,1,61.51,74.3,8.45,8.45,0,0,0,56.92,73a9.21,9.21,0,0,0-4.79,1.34,9.06,9.06,0,0,0-4.44,8.3,24.23,24.23,0,0,1,0,3.81,23.81,23.81,0,0,1-21.44,21.63,23.07,23.07,0,0,1-2.34.12h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 23.87,
    cy: 23.87,
    r: 23.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.43,32.33a10.69,10.69,0,1,0,3.28,14.76A10.69,10.69,0,0,0,228.43,32.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.05,105.18v6.5a4.43,4.43,0,0,1-4.43,4.43H201.5a2.48,2.48,0,0,1-2.48-2.48V103.24a2.49,2.49,0,0,1,2.48-2.49h14.57V77.15H201.39a2.48,2.48,0,0,1-2.48-2.48V64.34a2.48,2.48,0,0,1,2.48-2.48H227.1c2.9,0,5.25,2.64,5.25,5.89v33h12.27A4.44,4.44,0,0,1,249.05,105.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.17,92.7H394.1c.74,6.32,5,10.57,11.64,10.57A15.35,15.35,0,0,0,417,99a3.23,3.23,0,0,1,4.52-.07l5.3,5.12a2.29,2.29,0,0,1,.09,3.19Q418.79,116,406.15,116c-8.14,0-14.7-2.43-19.77-7.3s-7.52-11.32-7.52-19.46q0-11.9,7-19.66c4.65-5.18,10.79-7.83,18.5-7.83,8.15,0,14.29,2.64,18.51,7.83a28.14,28.14,0,0,1,6.46,18.72l-.05,1.43A3.1,3.1,0,0,1,426.17,92.7Zm-31.78-8.78h19.14c0-5.93-3.18-10.26-9.2-10.26-6.24,0-9.41,4.23-9.94,10.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M488.53,103.46a2.38,2.38,0,0,1,.16,3.25c-5.27,6.14-12.33,9.25-21.35,9.25-8.14,0-14.7-2.54-19.78-7.51S440,96.94,440,88.89s2.54-14.7,7.61-19.67,11.64-7.51,19.78-7.51c9,0,14.59,2.9,20.08,8.61a2.38,2.38,0,0,1-.06,3.36l-6,5.78a3.28,3.28,0,0,1-4.64-.11,12.25,12.25,0,0,0-8.89-4c-7.61,0-12.58,5.39-12.58,13.53s5,13.54,12.58,13.54a13.17,13.17,0,0,0,10-4.67,3.28,3.28,0,0,1,4.63-.13s0,0,.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.51,114.57a2.67,2.67,0,0,1-2.36,1.38H359.09a3.25,3.25,0,0,1-2.78-1.54l-7.94-13.72-8.19,13.93a2.84,2.84,0,0,1-2.4,1.33h-10a2.83,2.83,0,0,1-2.4-4.32L340,88.12,326.38,66.26a2.83,2.83,0,0,1,2.41-4.32h10a2.79,2.79,0,0,1,2.4,1.34l7.11,11.46,7-11.25a3.26,3.26,0,0,1,2.79-1.55h10.06a2.68,2.68,0,0,1,2.27,4.1L356.66,88.12l14.78,23.74A2.66,2.66,0,0,1,371.51,114.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M277.89,46v16h24.33a4.35,4.35,0,0,1,4.35,4.35v6.06a4.34,4.34,0,0,1-4.35,4.34H277.89v24H310a4.36,4.36,0,0,1,4.35,4.36v6.52A4.36,4.36,0,0,1,310,116h-46.1a4.36,4.36,0,0,1-4.35-4.35V35.17a4.35,4.35,0,0,1,4.35-4.35H310a4.35,4.35,0,0,1,4.35,4.35v6.46A4.36,4.36,0,0,1,310,46Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fccd1cf1de077edb9129755edf83da28.svg";
export { ForwardRef as ReactComponent };